// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__BL2Ng","right":"styles_right__1oynC"};